module.exports = __webpack_public_path__ + "img/default_startup_logo.b2cd3f49.svg";